import {Component, forwardRef, input, output, viewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {SimpleOption} from '@app/shared/model/simple-option';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {actionStatuses, TicketStatusId} from '@app/shared/services/api/tickets/tickets.interface';
import {MessageTranslateService} from '@app/shared/services/i18n/translate-service-service.service';
import {AppConstants} from '@shared/util/app-constants';


const options: SimpleOption<TicketStatusId, I18nMessage>[] = actionStatuses.map(status => ({
  label: {messageKey: status.display_text},
  value: status.status_id
}));

@Component({
  selector: 'app-ticket-status-select',
  templateUrl: './ticket-status-select.component.html',
  standalone: false,
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TicketStatusSelectComponent), multi: true}
  ]
})
export class TicketStatusSelectComponent {
  readonly options: SimpleOption<TicketStatusId>[];
  readonly valueKey: keyof SimpleOption = 'value';
  readonly labelKey: keyof SimpleOption = 'label';
  readonly DROPDOWN_HOLDER_SELECTOR = AppConstants.DROPDOWN_HOLDER_SELECTOR;

  maxSelectedLabels = input(1);
  placeholder = input<string | null>(null);
  multiSelect = input(true);
  openEvent = output<any>();
  closeEvent = output<any>();
  aceSelect = viewChild.required(AceSelectComponent);

  constructor(translateService: MessageTranslateService) {
    this.options = options.map(option => ({...option, label: translateService.instant(option.label)}));
  }

  writeValue(value: TicketStatusId[] | TicketStatusId): void {
    this.aceSelect().writeValue(value);
  }

  registerOnChange(fn: (value: TicketStatusId[] | TicketStatusId) => void): void {
    this.aceSelect().registerOnChange(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.aceSelect().registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.aceSelect().setDisabledState(isDisabled);
  }

  onOpenEvent(event: any): void {
    this.openEvent.emit(event);
  }

  onCloseEvent(event: any): void {
    this.closeEvent.emit(event);
  }
}
